import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const TranslationListContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 30px;
  box-shadow: 2px 4px 4px 0 rgb(0 0 0 / 25%);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  .table-container {
    padding: 0 30px;
  }
`;

export const ActionContainer = styled.div`
  float: right;
  padding-right: 30px;
`;

export const Title = styled.h2`
  width: 100%;
  text-align: center;
  font-family: "Lato";
  font-size: 22px;
  line-height: 22px;
  margin: 0 0 30px 0;
  color: #ff5200;
  text-transform: capitalize;
  font-weight: bold;
`;

export const CreateButton = styled(BaseButton)`
  background: #00aeea;
  margin-right: 10px;
  float: right;
  border: 1px solid #00aeea;
  font-weight: normal;
  width: auto;
  font-size: 16px;
  font-family: lato;
  margin-bottom: 0px;
  line-height: 35px;
  white-space: nowrap;
  border-bottom-left-radius: ${(props) =>
    props.displayDropdown ? "0px" : "4px"};
  border-bottom-right-radius: ${(props) =>
    props.displayDropdown ? "0px" : "4px"};
`;

export const RefreshButton = styled(BaseButton)`
  background: #00aeea;
  float: right;
  border: 1px solid #00aeea;
  font-weight: normal;
  width: auto;
  font-size: 16px;
  font-family: lato;
  margin-bottom: 0px;
  line-height: 35px;
  white-space: nowrap;
  border-bottom-left-radius: ${(props) =>
    props.displayDropdown ? "0px" : "4px"};
  border-bottom-right-radius: ${(props) =>
    props.displayDropdown ? "0px" : "4px"};
`;
